import Base from './Base'

const isBlank = (string) => {
  return string === '' || string === null || string === undefined
}

export default class ItineraryItem extends Base {
  constructor (data, container, isYgtBooking) {
    super(data, container, isYgtBooking)

    this.attributesForUpdates = []
  }

  get isRejected () {
    return this.confirmed === false
  }

  // Same as Rails: returns the object as a hash (*not* a string!).
  // Removes extraneous details like the originalData and callbacks
  asJSON () {
    const extraKeys = [
      'originalData',
      'errors',
      'attributesForUpdates',
      ...Object.keys(this.callbacks(null))
    ]
    const data = { ...this }
    extraKeys.forEach(key => delete data[key])
    return data
  }

  isRejectedWithoutReason () {
    return this.isRejected && isBlank(this.rejection_reason)
  }

  isConfirmedWithoutReference () {
    return this.confirmation_reference_required &&
      this.confirmed === true &&
      isBlank(this.confirmation_reference)
  }

  validateRejectedWithoutReason () {
    if (this.isRejectedWithoutReason()) {
      return { rejection_reason: ['blank'] }
    }
    return {}
  }

  validateConfirmedWithoutReference () {
    if (this.isConfirmedWithoutReference()) {
      return { confirmation_reference: ['blank'] }
    }
    return {}
  }

  validate () {
    return {
      ...super.validate(),
      ...this.validateRejectedWithoutReason(),
      ...this.validateConfirmedWithoutReference()
    }
  }

  update (attributeName, value) {
    this[attributeName] = value
    if (this.attributesForUpdates.includes(attributeName)) {
      this.updated = this.originalData[attributeName] !== value && this.originalData[attributeName] !== null
      this.initted = this.originalData[attributeName] !== value
    }
  }

  callbacks (container) {
    return {
      ...super.callbacks(container),

      updateAttribute: (id, attributeName, value) => {
        const item = container.itineraryItems.find(id)
        item.update(attributeName, value)
        item.errors = this.validate()

        return item
      }
    }
  }
}
